// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__TgnlS","gfeWrapper":"CalendarEvent_gfeWrapper__2XRlg"};